import { z } from "zod";
import { IsoDateString } from "./isoDate";

export const Organization = z.object({
    id: z.number(),
    name: z.string(),
    description: z.string().optional().nullish(),
    // Soft-delete marker (PRTL-1275), ISO string like every other deletedAt on
    // the wire (tRPC has no Date transformer). List/listAll never return
    // deleted orgs; `get` and rows that already reference an org may carry it.
    deletedAt: IsoDateString.nullable().optional(),
});
